// Auto-split from i18n.js — language: zh_TW
export default {
    translation: {
        // routes & menus
        Dashboard: '總覽',
        'Space Data': '空間數據',
        'Equipment Data': '設備數據',
        'Meter Data': '計量表數據',
        'Tenant Data': '租⼾數據',
        'Store Data': '⾨店數據',
        'Shopfloor Data': '⾞間數據',
        'Combined Equipment Data': '組合設備數據',
        'Auxiliary System': '輔助系統',
        Microgrid: '微電網',
        'Energy Storage Power Station': '儲能電站',
        'Photovoltaic Power Station': '電站',
        'Fault Alarm': '故障報警',
        Monitoring: '設備監控',
        'Advanced Reporting': '⾼級報表',
        'Knowledge Base': '知識庫',
        'Energy Category Data': '能耗分類分析',
        'Energy Item Data': '能耗分項分析',
        Carbon: '碳排放分析',
        Cost: '成本分析',
        Output: '產出分析',
        Income: '收入分析',
        Efficiency: '效率分析',
        Load: '負荷分析',
        Statistics: '統計分析',
        'Batch Analysis': '批量分析',
        Saving: '節能分析Ⓔ',
        Plan: '計劃分析Ⓔ',
        Prediction: 'PredictionⒺ',
        'Production': '產量',
        'Space Production': '產量能耗分析',
        'Equipment Tracking': '設備台賬',
        'Equipment Comparison': '對比分析',
        'Shopfloor Comparison': '對比分析',
        'Store Comparison': '對比分析',
        'Space Comparison': '對比分析',
        'Combined Equipment Comparison': '對比分析',
        'Tenant Comparison': '租戶對比',
        'Environment Monitor': '環境監測',
        'Meter Energy': '計量表能耗分析',
        'Meter Prediction': '計量表預測分析Ⓔ',
        'Virtual Meter Prediction': '虛擬表預測分析Ⓔ',
        'Offline Meter Prediction': '離線表預測分析Ⓔ',
        'Meter Carbon': '計量表碳排放分析',
        'Meter Cost': '計量表成本分析',
        'Meter Trend': '計量表趨勢分析',
        'Meter Realtime': '計量表實時分析',
        'Meter Saving': '計量表節能分析Ⓔ',
        'Meter Plan': '計量表計劃分析Ⓔ',
        'Master Meter Submeters Balance': '總分表平衡分析',
        'Meter Batch Analysis': '計量表批量分析',
        'Meter Comparison': '計量表對比分析',
        'Meter Tracking': '計量表台賬',
        'Virtual Meter Saving': '虛擬表節能分析Ⓔ',
        'Virtual Meter Plan': '虛擬表計劃分析Ⓔ',
        'Virtual Meter Energy': '虛擬表能耗分析',
        'Virtual Meter Carbon': '虛擬表碳排放分析',
        'Virtual Meter Cost': '虛擬表成本分析',
        'Virtual Meter Batch Analysis': '虛擬表批量分析',
        'Offline Meter Energy': '離線表能耗分析',
        'Offline Meter Carbon': '離線表碳排放分析',
        'Offline Meter Cost': '離線表成本分析',
        'Offline Meter Batch Analysis': '離線表批量分析',
        'Offline Meter Saving': '離線表節能分析Ⓔ',
        'Offline Meter Plan': '離線表計劃分析Ⓔ',
        'Offline Meter Input': '離線表數據錄入',
        'Tenant Bill': '租⼾賬單',
        'Energy Flow Diagram': '能流圖',
        'Distribution System': '配電系統',
        'SVG System': '組態可視化系統',
        'Faults Data': '故障分析',
        'Space Equipments': '空間設備',
        'Combined Equipments': '組合設備',
        'Energy Storage Power Station List': '電站列表',
        'Energy Storage Power Station Details': '設備監控',
        'Energy Storage Power Station Reporting': '數據報表',
        'Energy Storage Power Station Alarm': '故障報警',
        'Energy Storage Power Station Maintenance': '維護保養',
        'Enter Production': '產量錄入',
        'Multiple Microgrids': 'Multiple Microgirds',
        'Multiple Microgrids Dashboard': 'Dashboard',
        'Multiple Microgrids List': 'List',
        'Single Microgrid': 'Single Microgrid',
        'Single Microgrid Dashboard': 'Dashboard',
        'Single Microgrid Details': 'Details',
        'Single Microgrid Fault Alarm': 'Fault Alarm',
        'Microgrid Reports': 'Power Station Reports',
        'Microgrid Reports Energy': 'Energy',
        'Microgrid Reports Revenue': 'Revenue',
        'Microgrid Reports Parameters': 'Parameters',
        'Multiple Energy Storage Power Stations': '多站數據',
        'Multiple Energy Storage Power Stations Dashboard': '多站總覽',
        'Multiple Energy Storage Power Stations List': '電站列表',
        'Single Energy Storage Power Station': '單站數據',
        'Single Energy Storage Power Station Dashboard': '單站總覽',
        'Single Energy Storage Power Station Details': '設備數據',
        'Single Energy Storage Power Station Fault Alarm': '故障告警',
        'Energy Storage Power Station Reports': '統計報表',
        'Energy Storage Power Station Reports Energy': '電量報表',
        'Energy Storage Power Station Reports Revenue': '收益報表',
        'Energy Storage Power Station Reports Parameters': '數據査詢',
        'Photovoltaic Power Station List': '電站列表',
        'Photovoltaic Power Station Details': '設備監控',
        'Photovoltaic Power Station Reporting': '數據報表',
        'Photovoltaic Power Station Alarm': '故障報警',
        'Photovoltaic Power Station Maintenance': '維護保養',
        'Multiple Photovoltaic Power Stations': '多站數據',
        'Multiple Photovoltaic Power Stations Dashboard': '多站總覽',
        'Multiple Photovoltaic Power Stations List': '電站列表',
        'Single Photovoltaic Power Station': '單站數據',
        'Single Photovoltaic Power Station Dashboard': '單站總覽',
        'Single Photovoltaic Power Station Details': '設備數據',
        'Single Photovoltaic Power Station Fault Alarm': '故障告警',
        'Photovoltaic Power Station Reports': '統計報表',
        'Photovoltaic Power Station Reports Energy': '電量報表',
        'Photovoltaic Power Station Reports Revenue': '收益報表',
        'Photovoltaic Power Station Reports Parameters': '數據査詢',
        'Work Order': '⼯單管理',
        'Work Order Installation': '安裝記錄',
        'Work Order Repair': '維修記錄',
        'Work Order Inspection': '巡檢記錄',
        'Total Number of Work Orders': '工單總數',
        'Number of New Work Orders': '新工單數量',
        'Number of Inprogress Work Orders': '進行中的工單數量',
        'Number of Done Work Orders': '已完成工單數量',
        'Fuel Indicator': '耗油量',
        'Charge Energy Indicator': '充電能量',
        'Discharge Energy Indicator': '放電能量',
        'Charge Cost Indicator': '充電成本',
        'Discharge Revenue Indicator': '放電收益',
        'HVAC': '空調',
        'Fire Control': '消防',
        'Store Dashboard': '門市儀表板',
        'Comprehensive overview of store energy performance': '門市能源績效綜合概覽',
        'Total Stores': '門市總數',
        'Total Area': '總面積',
        'Active Meters': '活躍電錶數',
        'Active Alerts': '活動告警',
        'Total Energy Consumption': '總能耗',
        'Carbon Emissions': '碳排放',
        'Current Period': '當前週期',
        'Energy Consumption by Category': '按類別能耗分佈',
        'Cost Distribution by Category': '按類別成本分佈',
        'Monthly Energy & Cost Trends': '月度能耗與成本趨勢',
        'Top 5 Energy Consuming Stores': '能耗最高的前5家門市',
        'Energy Category Details': '能源類別詳情',
        'Store Performance Overview': '門市績效概覽',
        'YoY Change': '同比變化',
        'Per m²': '每平方米',
        'Usage Intensity': '使用強度',
        'Dashboard data loaded successfully': '儀表板數據加載成功',
        'Failed to load dashboard data': '加載儀表板數據失敗',
        'Store Name': '門店名稱',
        'Store Area': '門店面積',
        'Energy Consumption': '能耗',
        'Consumption': '消耗量',
        'last period': '上期',
        // Tenant Dashboard
        'Tenant Dashboard': '租戶儀表板',
        'Comprehensive overview of tenant energy performance': '租戶能源績效綜合概覽',
        'Total Tenants': '租戶總數',
        'Tenant Performance Overview': '租戶績效概覽',
        'Tenant Name': '租戶名稱',
        'Tenant Area': '租戶面積',
        'Tenant Type': '租戶類型',
        // Equipment Dashboard
        'Equipment Dashboard': '設備儀表板',
        'Total Equipments': '設備總數',
        'Equipment Performance Overview': '設備绩效概覽',
        'Equipment Name': '設備名稱',
        'Equipment Type': '設備類型',
        'Total Energy': '總能耗',
        'Total Sensors': '傳感器總數',
        'Increment Rate': '增長率',
        // Shopfloor Dashboard
        'Total Shopfloors': '車間總數',
        'Shopfloor Performance Overview': '車間績效概覽',
        'Shopfloor Name': '車間名稱',
        'Shopfloor Area': '車間面積',
        // Combined Equipment Dashboard
        'Total Combined Equipments': '組合設備總數',
        'Combined Equipment Performance Overview': '組合設備績效概覽',
        'Combined Equipment Name': '組合設備名稱',
        'Associated Equipments': '關聯設備數',
        // Dashboard
        'Welcome to QiXuan': '歡迎使⽤ QiXuan',
        'An Industry Leading Energy Management System': '⾏業領先的能源管理系統',
        "This Year's Consumption CATEGORY VALUE UNIT": '本年消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Year's Costs CATEGORY VALUE UNIT": '本年成本 {{CATEGORY}}{{VALUE}} {{UNIT}}',
        "This Month's Consumption CATEGORY VALUE UNIT": '本⽉消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        "This Month's Generation CATEGORY VALUE UNIT": "This Month's Generation {{CATEGORY}} {{VALUE}} {{UNIT}}",
        "This Month's Costs CATEGORY VALUE UNIT": '本⽉成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Consumption CATEGORY VALUE UNIT in The Same Period Last Year':
            '去年同期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Costs CATEGORY VALUE UNIT in The Same Period Last Year': '去年同期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'CATEGORY Consumption UNIT': '{{CATEGORY}} 消耗 {{UNIT}}',
        'CATEGORY Costs UNIT': '{{CATEGORY}} 成本 {{UNIT}}',
        // Entities
        Space: '空間',
        Equipment: '設備',
        Meter: '計量表',
        'Offline Meter': '離線表',
        'Virtual Meter': '虛擬表',
        Tenant: '租⼾',
        Store: '⾨店',
        Shopfloor: '⾞間',
        'Combined Equipment': '組合設備',
        'Cost Center': '成本中⼼',
        Name: '名稱',
        DisplayName: '顯⽰名',
        UserName: '⽤⼾名',
        Description: '描述',
        'Energy Category': '能源分類',
        'Child Spaces': '⼦空間',
        'Associated Equipment': '相關設備',
        //Energy Categories
        Electricity: '電',
        Water: '⾃來⽔',
        'Natural Gas': '天然氣',
        // SidePanelModal
        Settings: '設置',
        'Set your own customized style': '設置您的⾃定義樣式',
        'Color Scheme': '配⾊⽅案',
        'Choose the perfect color mode for your app': '為您的應⽤選擇理想的⾊彩模式',
        Light: '亮⾊',
        Dark: '暗⾊',
        'RTL Mode': 'RTL 模式',
        'Switch your language direction': '改變你的語⾔⽅向',
        'Fluid Layout': '流動布局',
        'Toggle container layout system': '切換容器布局系統',
        'Navigation Position': '導航欄位置',
        'Vertical': '垂直',
        'Top': '頂部',
        'Combo': '組合',
        'Transparent': '透明',
        'Inverted': '反色',
        'Card': '卡片',
        'Vibrant': '活力',
        'Select a suitable navigation system for your web application': '為您的 web 應⽤程序選擇合適的導航欄系統',
        'Vertical Nav': '垂直導航欄',
        'Top Nav': '頂部導航欄',
        'Vertical Navbar Style': '垂直導航欄樣式',
        'Switch between styles for your vertical navbar': '切換垂直導航欄的樣式',
        Language: '語⾔',
        'Switch between languages': '切換語⾔',
        'language-zh_CN': '简体中文',
        'language-en': 'English',
        'language-de': 'Deutsch',
        'language-fr': 'Français',
        'language-es': 'Español',
        'language-ru': 'Руссĸий',
        'language-ar': 'العربية',
        'language-vi': 'Tiếng Việt',
        'language-th': 'ภาษาไทย',
        'language-tr': 'Türkçe',
        'language-ms': 'Bahasa Melayu',
        'language-id': 'Bahasa Indonesia',
        'language-zh_TW': '繁體中⽂',
        'language-pt': 'Português',
        'language-ko_KR': '로그아웃',
        'language-it': 'Italiano',
        'language-pol': 'Polski',
        'language-nl': 'Nederlands',
        'language-jp': '日本語',
        'language-fa': 'فارسی',
        'Like What You See?': '喜歡這個系統?',
        'Get QiXuan now': '立即獲取 QiXuan',
        'PQ.About': '本分析涵蓋電壓偏差、電壓不平衡、頻率偏差與電流不平衡。電壓偏差以(U−Un)/Un×100%計算；頻率偏差以|f−fn|計算；三相不平衡以max(|Xi−Xavg|)/Xavg×100%計算，並要求三相通道時間對齊。結果基於所選計量表於報告期內之時間序列；若缺少三相通道或時間戳未對齊，將略過不平衡指標。瞬態尖峰或缺失採樣可能放大最差值，穩態評估建議參考合規率與P95等統計指標。',
        Purchase: '採購企業版',
        ContactInfo: '聯絡方式',
        ProductWebsite: '產品官網',
        CompanyWebsite: '公司官網',
        SalesPhone: '銷售電話',
        // Query Panels
        'Base Period Begins': '基準期開始',
        'Base Period Ends': '基準期結束',
        'Comparison Types': '比較類型',
        'Year-Over-Year': '去年同比',
        'Month-On-Month': '上⽉環比',
        'Free Comparison': '⾃由比',
        'None Comparison': '不比',
        'Reporting Period Begins': '報告期開始',
        'Reporting Period Ends': '報告期結束',
        '(Optional)': '(可選)',
        'Period Types': '時間尺度',
        Yearly: '年',
        Monthly: '⽉',
        Weekly: '周',
        Daily: '⽇',
        Hourly: '時',
        Submit: '提交',
        'Input Energy Category': '消耗能源分類',
        'Output Energy Category': '產出能源分類',
        'Fraction Parameter': '分式參數',
        Search: '搜索',
        //DateRangePicker
        sunday: '⽇',
        monday: '⼀',
        tuesday: '⼆',
        wednesday: '三',
        thursday: '四',
        friday: '五',
        saturday: '六',
        ok: '確定',
        today: '今天',
        yesterday: '昨天',
        hours: '時',
        minutes: '分',
        seconds: '秒',
        last7Days: '最近七天',
        tomorrow: '明天',
        dayAfterTomorrow: '後天',
        next7Days: '今後七天',
        'Select Date Range': '選擇⽇期範圍',
        //Card Summaries and Line Charts
        'Base Period': '基準期',
        'Reporting Period': '報告期',
        'Per Unit Area': '單位⾯積值',
        'Per Capita': '人均值',
        'Per Unit Production': '單位產品值',
        Baseline: '基線值',
        Actual: '實際值',
        'Baseline Value - Actual Value': '基線值-實際值',
        'Average Load': '平均負荷',
        'Maximum Load': '最⼤負荷',
        'Load Factor': '負荷系數',
        'Ratio of Average Load to Maximum Load': '平均負荷與最⼤負荷的比值',
        'Carbon Dioxide Emissions by Energy Category': '⼆氧化碳排放占比',
        'Costs by Energy Category': '成本占比',
        'Incomes by Energy Category': '收入占比',
        'Electricity Consumption by Time-Of-Use': '分時消耗電量',
        'Electricity Carbon Dioxide Emissions by Time-Of-Use': '分時⽤電排放⼆氧化碳',
        'Electricity Cost by Time-Of-Use': '分時⽤電成本',
        'CATEGORY UNIT Consumption by Energy Items': '{{CATEGORY}}{{UNIT}} 分項消耗占比',
        'Ton of Standard Coal by Energy Category': '噸標準煤 (TCE) 占比',
        'Ton of Carbon Dioxide Emissions by Energy Category': '噸⼆氧化碳排放 (TCO2E) 占比',
        'Reporting Period Consumption CATEGORY UNIT': '報告期消耗{{CATEGORY}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY UNIT': 'Reporting Period Prediction {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{EQUIPMENT}} 報告期消耗 {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Consumption CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 報告期消耗 {{CATEGORY}} {{UNIT}}',
        'CATEGORY VALUE UNIT': '{{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption CATEGORY VALUE UNIT': '報告期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Prediction CATEGORY VALUE UNIT': 'Reporting Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Production PRODUCT VALUE UNIT': '報告期產量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Production PRODUCT VALUE UNIT': '基準期產量 {{PRODUCT}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption CATEGORY VALUE UNIT': '基準期消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Prediction CATEGORY VALUE UNIT': 'Base Period Prediction {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY UNIT': '報告期消耗 {{ITEM}} {{CATEGORY}} {{UNIT}}',
        'Reporting Period Consumption ITEM CATEGORY VALUE UNIT': '報告期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Consumption ITEM CATEGORY VALUE UNIT': '基準期消耗 {{ITEM}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Child Space Proportion CATEGORY UNIT': '⼦空間分類占比 {{CATEGORY}} {{UNIT}}',
        'Child Space Total Proportion': '⼦空間總計占比',
        'Reporting Period Carbon Dioxide Emissions CATEGORY UNIT': '報告期⼆氧化碳排放 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Carbon Dioxide Emissions CATEGORY VALUE UNIT':
            '報告期⼆氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Carbon Dioxide Emissions CATEGORY VALUE UNIT': '基準期⼆氧化碳排放 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Costs CATEGORY UNIT': '報告期成本 {{CATEGORY}}{{UNIT}}',
        'Reporting Period Costs CATEGORY VALUE UNIT': '報告期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Costs CATEGORY VALUE UNIT': '基準期成本 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Output CATEGORY UNIT': '報告期產出 {{CATEGORY}} {{UNIT}}',
        'EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{EQUIPMENT}} 報告期產出 {{CATEGORY}} {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Output CATEGORY UNIT':
            '{{COMBINED_EQUIPMENT}} 報告期產出 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Output CATEGORY VALUE UNIT': '報告期產出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Output CATEGORY VALUE UNIT': '基準期產出 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Income CATEGORY UNIT': '報告期收入 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Income CATEGORY VALUE UNIT': '報告期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Income CATEGORY VALUE UNIT': '基準期收入 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Total Income UNIT': '報告期總收入 {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME UNIT': '報告期累積效率 {{NAME}} {{UNIT}}',
        'EQUIPMENT Reporting Period Cumulative Efficiency UNIT':
            '{{EQUIPMENT}} 報告期累積效率 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency UNIT':
            '{{COMBINED_EQUIPMENT}} 報告期累積綜合效率 {{UNIT}}',
        'COMBINED_EQUIPMENT Reporting Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 報告期累積綜合效率 {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT Base Period Cumulative Comprehensive Efficiency VALUE UNIT':
            '{{COMBINED_EQUIPMENT}} 基準期累積綜合效率 {{VALUE}} {{UNIT}}',
        'Instantaneous Efficiency UNIT': '瞬時效率 {{UNIT}}',
        'EQUIPMENT Instantaneous Efficiency UNIT': '{{EQUIPMENT}} 瞬時效率 {{UNIT}}',
        'Equipment Efficiency Indicator': '設備能效指標',
        'COMBINED_EQUIPMENT Instantaneous Comprehensive Efficiency UNIT': '{{COMBINED_EQUIPMENT}} 瞬時綜合效率 {{UNIT}}',
        'Reporting Period Cumulative Efficiency VALUE UNIT': '報告期累積效率 {{VALUE}} {{UNIT}}',
        'Reporting Period Cumulative Efficiency NAME VALUE UNIT': '報告期累積效率 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency VALUE UNIT': '基準期累積效率 {{VALUE}} {{UNIT}}',
        'Base Period Cumulative Efficiency NAME VALUE UNIT': '基準期累積效率 {{NAME}} {{VALUE}} {{UNIT}}',
        'Base Period CATEGORY Maximum Load UNIT': '基準期 {{CATEGORY}} 最⼤負荷 {{UNIT}}',
        'Reporting Period CATEGORY Maximum Load UNIT': '報告期 {{CATEGORY}} 最⼤負荷 {{UNIT}}',
        'Reporting Period CATEGORY Average Load UNIT': '報告期 {{CATEGORY}} 平均負荷 {{UNIT}}',
        'Reporting Period CATEGORY Load Factor': '報告期 {{CATEGORY}} 負荷系數',
        'Base Period CATEGORY Average Load VALUE UNIT': '基準期 {{CATEGORY}} 平均負荷 {{VALUE}} {{UNIT}}',
        'Reporting Period CATEGORY Average UNIT': '報告期 {{CATEGORY}} 平均值 {{UNIT}}',
        'Reporting Period CATEGORY Maximum UNIT': '報告期 {{CATEGORY}} 最⼤值 {{UNIT}}',
        'Reporting Period CATEGORY Minimum UNIT': '報告期 {{CATEGORY}} 最⼩值 {{UNIT}}',
        'Reporting Period CATEGORY Mean UNIT': '報告期 {{CATEGORY}} 算術平均數 {{UNIT}}',
        'Reporting Period CATEGORY Median UNIT': '報告期 {{CATEGORY}} 中位數 {{UNIT}}',
        'Reporting Period CATEGORY Stdev UNIT': '報告期 {{CATEGORY}} 樣本標準差 {{UNIT}}',
        'Reporting Period CATEGORY Variance UNIT': '報告期 {{CATEGORY}} 樣本⽅差 {{UNIT}}',
        'Reporting Period Saving CATEGORY (Baseline - Actual) UNIT': '報告期節約 {{CATEGORY}} (基線-實際) {{UNIT}}',
        'Reporting Period Decreased CATEGORY (Baseline - Actual) UNIT': '報告期減少 {{CATEGORY}} (基線-實際) {{UNIT}}',
        'Reporting Period Saving CATEGORY VALUE UNIT': '報告期節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Base Period Saving CATEGORY VALUE UNIT': '基準期節約 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY UNIT': '報告期總表消耗 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Master Meter Consumption CATEGORY VALUE UNIT': '報告期總表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY UNIT': '報告期分表消耗 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Submeters Consumption CATEGORY VALUE UNIT':
            '報告期分表消耗 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Reporting Period Difference CATEGORY UNIT': '報告期差值 {{CATEGORY}} {{UNIT}}',
        'Reporting Period Percentage Difference': '報告期差值百分比',
        'Reporting Period Difference CATEGORY VALUE UNIT': '報告期差值 {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'Trend Values': '趨勢值',
        'METER CATEGORY VALUE UNIT': '{{METER}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'EQUIPMENT CATEGORY VALUE UNIT': '{{EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'COMBINED_EQUIPMENT CATEGORY VALUE UNIT': '{{COMBINED_EQUIPMENT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'SHOPFLOOR CATEGORY VALUE UNIT': '{{SHOPFLOOR}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        'TENANT CATEGORY VALUE UNIT': '{{TENANT}} {{CATEGORY}} {{VALUE}} {{UNIT}}',
        //FDD
        'Fault List': '故障列表',
        'Reporting Period Number of Fault VALUE': '報告期故障數: {{VALUE}}',
        'All Faults': '全部故障',
        'Space Faults': '空間故障',
        'Number of All Faults': '全部故障數',
        'Number of Space Faults': '空間故障數',
        'Total Number of Faults': '總故障數量',
        'Number of New Faults': '新發故障數量',
        'Number of Inprogress Faults': '進⾏中故障數量',
        'Number of Done Faults': '已完成故障數量',
        //Data Panels
        'Ton of Standard Coal': '噸標準煤',
        'Ton of Carbon Dioxide Emissions': '噸⼆氧化碳排放',
        'Carbon Emissions Per Unit Of Energy Consumption': '單位能耗碳排放',
        'Operating Characteristic Curve': '運⾏曲線',
        Tariff: '費率',
        'Detailed Data': '詳細數據',
        'Child Spaces Data': '⼦空間數據',
        'Associated Equipment Data': '相關設備數據',
        'This Year': '本年',
        'The Same Period Last Year': '去年同期',
        'This Month': '本⽉',
        'This Day': '本⽇',
        Total: '總計',
        'No data found': '沒有數據',
        Export: '導出',
        'AI Analysis': 'AI分析',
        Datetime: '⽇期時間',
        'Time-Of-Use Type': '分時類型',
        'Top-Peak': '尖',
        'On-Peak': '峰',
        'Mid-Peak': '平',
        'Off-Peak': '⾕',
        'Deep': '深谷',
        Percentage: '百分比',
        //Realtime Chart
        'Trend in the last hour of Energy Value Point': '能耗值點最近⼀⼩時趨勢',
        Circuit: '回路',
        Point: '數據點',
        'Realtime Value': '實時值',
        //Meter Tracking
        'Meter List': '計量表列表',
        'Edit Meter': '編輯',
        'Start Value': '起始值',
        'End Value': '結束值',
        'Difference Value': '差值',
        'Start Integrity Rate': '起始數據完整率 (%)',
        'End Integrity Rate': '結束數據完整率 (%)',
        'Full Integrity Rate': '整體數據完整率 (%)',
        'Start Integrity Rate Description': '起始資料完整率：統計時段內，所有儀表中成功取得起始時點能耗讀數的儀表占比',
        'End Integrity Rate Description': '結束資料完整率：統計時段內，所有儀表中成功取得結束時點能耗讀數的儀表占比',
        'Full Integrity Rate Description': '全量資料完整率：統計時段內，同時成功取得起始、結束時點能耗讀數的儀表占比',
        //Equipment Tracking
        'Equipment List': '設備列表',
        'Edit Equipment': '編輯',
        //Profile Dropdown
        Feedback: '反饋',
        'Account Settings': '賬號設置',
        Logout: '退出',
        //Authentication
        'Log in': '登錄',
        'Email address': '電⼦郵件地址',
        'Phone Number': '電話號碼',
        Password: '密碼',
        CaptchaCode: '驗證碼',
        Refresh: '刷新',
        'Remember me': '記住我',
        'Logged in as ': '已登錄 ',
        'Forgot Password?': '忘記密碼?',
        'Forgot your password?': '忘記你的密碼?',
        "Enter your email and we'll send you a reset link": '輸入電⼦郵件地址，我們會把重置鏈接發送給您',
        "Enter your email and we'll send you a registration link": '輸入電⼦郵件地址，我們會把注冊鏈接發送給您',
        'Reset Password': '重置密碼',
        'Thanks for using QiXuan!': '感謝您使⽤ QiXuan!',
        'You are now successfully signed out': '您已成功退出',
        'Return to Login': '返回登錄',
        'Please check your email!': '請查收您的電⼦郵件!',
        'An email has been sent to ': '⼀封電⼦郵件已經發送⾄ ',
        'Please click on the included link to reset your password': '請點擊⾥⾯的鏈接重置您的密碼',
        'Please click on the included link to register your account': '請點擊⾥⾯的鏈接注冊您的賬⼾',
        'An email with password reset link is sent to ': '⼀封包含密碼重置鏈接的電⼦郵件已經發送⾄ ',
        'Change Password': '修改密碼',
        'Old Password': '原密碼',
        'New Password': '新密碼',
        'Confirm Password': '重覆新密碼',
        'Update Password': '更新密碼',
        'Password has been changed!': '密碼已修改!',
        'Verification code has been sent to your inbox. \
Please copy it to the input box below.':
            '驗證碼已發送到您的收件箱，請將其覆制到下⾯的輸入框中。',
        'New to QiXuan': '初次使⽤ QiXuan',
        'Create an account': '注冊賬⼾',
        'EMAIL Account registration successful': '{{EMAIL}} 賬號注冊成功',
        'Thanks for verifying your account!': '感謝您驗證您的賬⼾！',
        'Your code is': '您的代碼是',
        'Send verification code': '發送驗證碼',
        'Please wait for NUMBER seconds': '請等待 {{NUMBER}} 秒',
        'Password reset': '密碼重置',
        'Please wait for approval': '請等待審核',
        //notification
        Notifications: '通知',
        'Mark all as read': '全部設為已讀',
        'View all': '全部',
        'Notification New': '新的',
        'Notification Earlier': '更早的',
        'Notification List': '通知列表',
        'Bulk actions': '批量操作',
        'Notification Subject': '主題',
        'Notification Created Datetime': '創建時間',
        'Notification Message': '內容',
        'Notification Priority': '優先級',
        'Notification Status': '狀態',
        'Notification Mark As Read': '標記為已讀',
        'Notification Mark As Acknowledged': '確認',
        'Notification Low': '低',
        'Notification Medium': '中',
        'Notification High': '⾼',
        'Notification Critical': '嚴重',
        'Notification Unread': '未讀',
        'Notification Read': '已讀',
        'Notification Acknowledged': '已確認',
        'Notification Archive': '存檔',
        'Notification Delete': '刪除',
        'Notification Apply': '應⽤',
        'Notification Start Datetime': '開始時間',
        'Notification End Datetime': '結束時間',
        'Notification Update Datetime': '更新時間',
        //Monitoring
        'Run Commands': '運⾏指令',
        'Pin Code': '密碼',
        'Unlock': '解鎖',
        'Set Value': '設定值',
        'Fault Alarms': '故障報警',
        'Instantaneous Efficiency VALUE UNIT': '瞬時效率 {{VALUE}} {{UNIT}}',
        'Communication Status': '通信狀態',
        'Communication Online': '在線',
        'Communication Offline': '離線',
        'Equipment Status': '設備狀態',
        'Equipment Running': '運⾏',
        'Equipment Stopped': '停機',
        'Show Up to': '每⾴顯⽰數量',
        All: '全部',
        'FROM - TO of TOTAL': '當前顯⽰ {{FROM}} - {{TO}} 總計 {{TOTAL}}',
        //Microgrid
        'Microgrid Energy': '微電網能源',
        'Microgrid Revenue': '微電網收益',
        'Microgrid Carbon': '微電網碳排放',
        'Photovoltaic Generation': '光伏發電量',
        'EV Charger Consumption': '充電樁用電量',
        'Load Consumption': '負載用電量',
        'Grid Buy': '從電網購買電量',
        'Grid Sell': '向電網銷售電量',
        'EV Charger': '電動汽車充電器',
        'Heat Pump': '熱泵',
        'Photovoltaic': '光電',
        'PCS Run State': 'PCS 運⾏狀態',
        'PCS Unknown': '未知',
        'PCS Initializing': '初始上電',
        'PCS Standby': '待機',
        'PCS Shutdown': '關機',
        'PCS Fault': '故障',
        'PCS Running': '運⾏',
        'Battery Power': '電池功率',
        'Photovoltaic Power': '光伏功率',
        'Grid Power': '電網功率',
        'Load Power': '負載功率',
        Reporting: '數據報表',
        Maintenance: '維護保養',
        'General Information': '基本信息',
        'Serial Number': '序列號',
        Address: '地址',
        'Postal Code': '郵編',
        'Rated Capacity': '額定容量',
        'Rated Power': '額定功率',
        Latitude: '緯度',
        Longitude: '經度',
        'Strategy Management': '策略管理',
        'Charging Schedule': '充電時間表',
        'Charge Start Time': '充電開始時間',
        'Charge End Time': '充電結束時間',
        'Discharge Start Time': '放電開始時間',
        'Discharge End Time': '放電結束時間',
        'Total Rated Power': '總額定功率',
        'Total Rated Capacity': '總額定容量',
        "Today's Charge": '今日充電量',
        "Today's Discharge": '今日放電量',
        "Today's Generation": "今日發電量",
        'Total Fuel Consumption': '總耗油量',
        'Total Charge': '總充電',
        'Total Discharge': '總放電',
        'Total Generation': '總發電量',
        'Total Revenue': '總收益',
        'Total Photovoltaic Generation': '總光伏發電量',
        'Total EV Charger Consumption': '充電樁總用電量',
        'Total Load Consumption': '負載總用電量',
        'Total Grid Buy': '從電網購買總電量',
        'Total Grid Sell': '向電網銷售總電量',
        'Total Efficiency': '總效率',
        'Discharge Achievement Rate': '放電達成率',
        // Revenue Indicator
        "Today's Cost": "今日成本",
        "Today's Income": "今日收入",
        "Total Cost": "總成本",
        "Total Income": "總收入",
        "Today's Revenue": "今日利潤",

        'Revenue Ranking': '收益排名',
        'Efficiency Ranking': '效率排名',
        'Charge Ranking': '充電排名',
        'Discharge Ranking': '放電排名',
        'Number of Microgrids': '微電網數',
        'Number of Power Stations': '電站數',
        'Microgrid List': '微電網列表',
        'Select Microgrid': '選擇微電網',
        'Previous Page': '上⼀⾴',
        'Next Page': '下⼀⾴',
        '7 Days': '7⽇',
        'Charge UNIT': '充 {{UNIT}}',
        'Discharge UNIT': '放 {{UNIT}}',
        'Generation UNIT': '發電 {{UNIT}}',
        'Energy Indicator': '能量指標',
        'Revenue Indicator': '收益指標',
        'Carbon Indicator': '碳指標',

        // Energy Storage Power Station
        'Battery Operating State': '電池運⾏狀態',
        'Battery State': '電池狀態',
        'Battery Unknown': '未知',
        'Battery Stopped': '停⽌',
        'Battery Reserved': 'Reserved', // 0
        'Battery Fault': '故障', // 1
        'Battery Warning': '預警', // 2
        'Battery Standby': '待機', // 3
        'Battery Prohibit DisCharging': '禁放', // 4
        'Battery Prohibit Charging': '禁充', // 5
        'Battery Normal': '正常', // 6
        'Battery Charging': '充電', // 7
        'Battery Discharging': '放電', // 8
        'Battery Idle': '空闲', // 9
        'Phase of Lifecycle': '生命週期階段',
        'Use Phase': '使用階段',
        'Commissioning Phase': '調試階段',
        'Commissioning Date': 'Commissioning Date',
        'Installation Phase': '安裝階段',
        'Device Status': '設備狀態',
        'Basic Information': '基本訊息',
        'Gateway': 'Gateway',
        'Grid Meter': '電網電錶',
        'Load Meter': '負載電錶',
        'ESS Meter': 'ESS Meter',
        'Total Active Power': 'Total Active Power',
        'Active Power A': 'Active Power A',
        'Active Power B': 'Active Power B',
        'Active Power C': 'Active Power C',
        'Total Reactive Power': 'Total Reactive Power',
        'Reactive Power A': 'Reactive Power A',
        'Reactive Power B': 'Reactive Power B',
        'Reactive Power C': 'Reactive Power C',
        'Total Apparent Power': 'Total Apparent Power',
        'Apparent Power A': 'Apparent Power A',
        'Apparent Power B': 'Apparent Power B',
        'Apparent Power C': 'Apparent Power C',
        'Total Power Factor': 'Total Power Factor',
        'Active Energy Import': 'Active Energy Import',
        'Active Energy Export': 'Active Energy Export',
        'Active Energy Net': 'Active Energy Net',

        'Generator': 'Generator',

        // Photovoltaic Power Station
        'Invertor': '逆變器',
        'Invertor Run State': '逆變器運⾏狀態',
        'Invertor Unknown': '未知',
        'Invertor Initializing': '初始上電',
        'Invertor Standby': '待機',
        'Invertor Shutdown': '關機',
        'Invertor Fault': '故障',
        'Invertor Running': '運⾏',

        //Advanced Reporting & Knowledge Base
        'Created Datetime': '⽣成時間',
        'File Format': '⽂件格式',
        'File Size': '⽂件⼤⼩',
        Uploader: '上傳者',
        'Upload Datetime': '上傳時間',
        //Error
        "The page you're looking for is not found": '您要找的⾴⾯不存在',
        "Make sure the address is correct and that the page hasn't moved":
            '請確認地址正確且⾴⾯沒有被移動',
        'If you think this is a mistake,': '如果您認為這是⼀個錯誤,',
        'contact us': '聯系我們',
        'Take me home': '帶我回⾸⾴',
        'Whoops, something went wrong!': '哦, 出錯了！!',
        'Try refreshing the page, or going back and attempting the action again':
            '請嘗試刷新⾴⾯, 或回退並再次嘗試執⾏這個操作',
        'If this problem persists,': '如果問題依然存在,',
        'Captcha Error': '驗證碼錯誤',
        'Confirm Password Error': '兩次密碼不⼀致',
        'It looks like you clicked on an invalid password reset link. Please tryagain.':
            '看起來你點擊了⼀個無效的重置密碼鏈接。請再試⼀次。',
        'It looks like you clicked on an invalid registration account link. Please tryagain.':
            '看起來你點擊了⼀個無效的注冊賬號鏈接。請再試⼀次。',
        //Tenant Bill
        'Lease Contract Number': '租賃合同號碼',
        Download: '下載',
        Print: '打印',
        'Payment Notice': '付款通知書',
        'Bill To': '致',
        'Bill Number': '賬單號碼',
        'Bill Date': '賬單⽇期',
        'Payment Due Date': '付款到期⽇',
        'Amount Payable': '應付款⾦額',
        'Billing Period Start': '結算期起始⽇期',
        'Billing Period End': '結算期結束⽇期',
        Quantity: '數量',
        Price: '價格',
        Unit: '單位',
        Amount: '⾦額',
        Subtotal: '⼩計',
        'VAT Output Tax': '增值稅銷項稅⾦',
        'Total Amount Payable': '應付⾦額合計',
        'Please make sure to pay on or before the payment due date above':
            '請確保在上述付款到期⽇或之前付款',
        'Send money to the following account': '匯款⾄以下賬⼾',
        'Account Name': '賬⼾名稱',
        'Bank Name': '開⼾銀⾏',
        'Bank Address': '銀⾏地址',
        'RMB Account': '⼈⺠幣賬⼾',
        // button
        'Toggle Navigation': '切換導航',
        // working calendar
        'Working Days': '⼯作⽇',
        'Non Working Days': '非⼯作⽇',
        'Select Row': '請選擇要操作的數據⾏',
        // Offline Meter Input
        'Daily Value': '⽇數據',
        Date: '⽇期',
        'Successfully Saved': '保存成功',
        'Previous Data Is Empty': '之前的數據為空',
        // API
        'API.ACCOUNT_UNLOCK_FAILED': 'Account unlock failed',
        'API.ADMINISTRATOR_SESSION_NOT_FOUND': '管理員會話不存在',
        'API.ADMINISTRATOR_SESSION_TIMEOUT': '管理員會話已超時',
        'API.ADVANCED_REPORT_NOT_FOUND': '⾼級報表不存在',
        'API.API_KEY_HAS_EXPIRED': 'Key has expired',
        'API.API_KEY_NAME_IS_ALREADY_IN_USE': 'Key name is already in use',
        'API.API_KEY_NOT_FOUND': 'Key not found',
        'API.BAD_REQUEST': '錯誤請求',
        'API.BALANCING_PRICE_POINT_NOT_FOUND': 'Balancing price point not found',
        'API.BATTERY_STATE_POINT_NOT_FOUND': 'Battery state point not found',
        'API.BUY_METER_NOT_FOUND': 'Buy meter not found',
        'API.CANNOT_SET_EXISTING_SUBMETER_AS_MASTER_METER': '不能將已經設為分表的計量表設置為總表',
        'API.CHARGE_METER_NOT_FOUND': 'Charge meter not found',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_EXISTS':
            'Combined equipment command relation exists',
        'API.COMBINED_EQUIPMENT_COMMAND_RELATION_NOT_FOUND':
            'Combined equipment command relation not found',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_EXISTS': '組合設備與設備關系已存在',
        'API.COMBINED_EQUIPMENT_EQUIPMENT_RELATION_NOT_FOUND':
            '組合設備與設備關系不存在',
        'API.COMBINED_EQUIPMENT_METER_RELATION_EXISTS': '組合設備與計量表關系已存在',
        'API.COMBINED_EQUIPMENT_METER_RELATION_NOT_FOUND': '組合設備與計量表關系不存在',
        'API.COMBINED_EQUIPMENT_NAME_IS_ALREADY_IN_USE': '組合設備名稱已使⽤',
        'API.COMBINED_EQUIPMENT_NOT_FOUND': '組合設備不存在',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_EXISTS':
            '組合設備與離線表關系已存在',
        'API.COMBINED_EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '組合設備與離線表關系不存在',
        'API.COMBINED_EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE':
            '組合設備相關參數名稱已使⽤',
        'API.COMBINED_EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '組合設備相關參數不存在或不匹配',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS':
            '組合設備與虛擬表關系已存在',
        'API.COMBINED_EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '組合設備與虛擬表關系不存在',
        'API.COMMAND_NAME_IS_ALREADY_IN_USE': 'Command name is already in use',
        'API.COMMAND_NOT_FOUND': 'Command not found',
        'API.CONTACT_NAME_IS_ALREADY_IN_USE': '聯系⼈姓名已使⽤',
        'API.CONTACT_NOT_FOUND': '聯系⼈不存在',
        'API.COOLING_METER_NOT_FOUND': 'Cooling meter not found',
        'API.COST_CENTER_EXTERNAL_ID_EXISTS': '成本中⼼外部 ID 已存在',
        'API.COST_CENTER_NAME_EXISTS': '成本中⼼名稱已存在',
        'API.COST_CENTER_NOT_FOUND': '成本中⼼不存在',
        'API.COST_FILE_NOT_FOUND': '成本⽂件不存在',
        'API.DATA_REPAIR_FILE_NOT_FOUND': 'Data repair file not found',
        'API.DATA_SOURCE_NAME_IS_ALREADY_IN_USE': '數據源名稱已使⽤',
        'API.DATA_SOURCE_NOT_FOUND': '數據源不存在',
        'API.DATABASE_ERROR': '數據庫錯誤',
        'API.DATE_IS_ALREADY_IN_WORKING_CALENDAR': '⽇期已在⼯作⽇歷中',
        'API.DATE_LOCAL_NOT_FOUND': '未找到本地⽇期',
        'API.DISCHARGE_METER_NOT_FOUND': 'Discharge meter not found',
        'API.DISTRIBUTION_CIRCUIT_NAME_IS_ALREADY_IN_USE': '配電回路名稱已使⽤',
        'API.DISTRIBUTION_CIRCUIT_NOT_FOUND': '配電回路不存在',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_EXISTS': '配電回路與點位關系已存在',
        'API.DISTRIBUTION_CIRCUIT_POINT_RELATION_NOT_FOUND': '配電回路與點位關系不存在',
        'API.DISTRIBUTION_SYSTEM_NAME_IS_ALREADY_IN_USE': '配電系統名稱已使⽤',
        'API.DISTRIBUTION_SYSTEM_NOT_FOUND': '配電系統不存在',
        'API.ELECTRICITY_METER_NOT_FOUND': 'Electricity meter not found',
        'API.EMAIL_IS_ALREADY_IN_USE': '電⼦郵箱已使⽤',
        'API.EMAIL_MESSAGE_NOT_FOUND': '電⼦郵件消息不存在',
        'API.EMAIL_NOT_FOUND': '電⼦郵箱不存在',
        'API.EMAIL_SERVER_HOST_IS_ALREADY_IN_USE': '郵件服務器主機已使⽤',
        'API.EMAIL_SERVER_NOT_FOUND': '郵件服務器主機不存在',
        'API.EMPTY_VARIABLES_ARRAY': '空變量數組',
        'API.ENERGY_CATEGORY_NAME_IS_ALREADY_IN_USE': '能源分類名稱已使⽤',
        'API.ENERGY_CATEGORY_NOT_FOUND': '能源分類不存在',
        'API.ENERGY_CATEGORY_USED_IN_ENERGY_ITEMS': '能源分類在能源分項中已使⽤',
        'API.ENERGY_CATEGORY_USED_IN_METER': '能源分類在計量表中已使⽤',
        'API.ENERGY_CATEGORY_USED_IN_OFFLINE_METER': '能源分類在離線表中已使⽤',
        'API.ENERGY_CATEGORY_USED_IN_TARIFFS': '能源分類在費率中已使⽤',
        'API.ENERGY_CATEGORY_USED_IN_VIRTUAL_METER': '能源分類在虛擬表中已使⽤',
        'API.ENERGY_FLOW_DIAGRAM_LINK_IS_ALREADY_IN_USE': '能流圖鏈接已使⽤',
        'API.ENERGY_FLOW_DIAGRAM_LINK_NOT_FOUND_OR_NOT_MATCH':
            '能流圖鏈接不存在或不匹配',
        'API.ENERGY_FLOW_DIAGRAM_NAME_IS_ALREADY_IN_USE': '能流圖名稱已使⽤',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NAME_IS_ALREADY_IN_USE':
            '能流圖節點已使⽤',
        'API.ENERGY_FLOW_DIAGRAM_NODE_NOT_FOUND_OR_NOT_MATCH':
            '能流圖節點不存在或不匹配',
        'API.ENERGY_FLOW_DIAGRAM_NOT_FOUND': '能流圖不存在',
        'API.ENERGY_ITEM_DOES_NOT_BELONG_TO_ENERGY_CATEGORY':
            '能源分項不屬於能源分類',
        'API.ENERGY_ITEM_IS_NOT_BELONG_TO_ENERGY_CATEGORY': '能源分項不屬於能源分類',
        'API.ENERGY_ITEM_NAME_IS_ALREADY_IN_USE': '能源分項已使⽤',
        'API.ENERGY_ITEM_NOT_FOUND': '能源分項不存在',
        'API.ENERGY_ITEM_USED_IN_METER': '能源分項在計量表中已使⽤',
        'API.ENERGY_ITEM_USED_IN_OFFLINE_METER': '能源分項在離線表中已使⽤',
        'API.ENERGY_ITEM_USED_IN_VIRTUAL_METER': '能源分項在虛擬表中已使⽤',
        'API.ENERGY_STORAGE_POWER_STATION_NAME_IS_ALREADY_IN_USE':
            'Energy storage power station name is already in use',
        'API.ENERGY_STORAGE_POWER_STATION_NOT_FOUND': 'Energy storage power station not found',
        'API.EQUIPMENT_COMMAND_RELATION_EXISTS': 'Equipment command relation exists',
        'API.EQUIPMENT_COMMAND_RELATION_NOT_FOUND': 'Equipment command relation not found',
        'API.EQUIPMENT_METER_RELATION_EXISTS': '設備與計量表關系已存在',
        'API.EQUIPMENT_METER_RELATION_NOT_FOUND': '設備與計量表關系不存在',
        'API.EQUIPMENT_NAME_IS_ALREADY_IN_USE': '設備名稱已使⽤',
        'API.EQUIPMENT_NOT_FOUND': '設備不存在',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_EXISTS': '設備與離線表關系已存在',
        'API.EQUIPMENT_OFFLINE_METER_RELATION_NOT_FOUND': '設備與離線表關系不存在',
        'API.EQUIPMENT_PARAMETER_NAME_IS_ALREADY_IN_USE': '設備相關參數名稱已使⽤',
        'API.EQUIPMENT_PARAMETER_NOT_FOUND_OR_NOT_MATCH': '設備相關參數不存在或不匹配',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_EXISTS': '設備與虛擬表關系已存在',
        'API.EQUIPMENT_VIRTUAL_METER_RELATION_NOT_FOUND': '設備與虛擬表關系不存在',
        'API.ERROR': '錯誤',
        'API.EXCEPTION': '異常',
        'API.FAILED_TO_READ_REQUEST_STREAM': 'Failed to read request stream',
        'API.FAILED_TO_RESTORE_COST_FILE': '恢覆成本⽂件失敗',
        'API.FAILED_TO_RESTORE_DATA_REPAIR_FILE': 'Failed to restore data repair file',
        'API.FAILED_TO_RESTORE_KNOWLEDGE_FILE': '恢覆知識⽂件失敗',
        'API.FAILED_TO_RESTORE_OFFLINE_METER_FILE': '恢覆離線表⽂件失敗',
        'API.FAILED_TO_SAVE_OFFLINE_METER_FILE': '保存離線表⽂件失敗',
        'API.FAILED_TO_UPLOAD_ATTACHMENT_FILE': 'Failed to upload attachment file',
        'API.FAILED_TO_UPLOAD_COST_FILE': '上傳成本⽂件失敗',
        'API.FAILED_TO_UPLOAD_DATA_REPAIR_FILE': 'Failed to upload data repair file',
        'API.FAILED_TO_UPLOAD_KNOWLEDGE_FILE': '上傳知識⽂件失敗',
        'API.FAILED_TO_UPLOAD_OFFLINE_METER_FILE': '上傳離線表⽂件失敗',
        'API.GATEWAY_NAME_IS_ALREADY_IN_USE': '網關名稱已使⽤',
        'API.GATEWAY_NOT_FOUND': '網關不存在',
        'API.HEAT_METER_NOT_FOUND': 'Heat meter not found',
        'API.INVALID_': '無效的 ',
        'API.INVALID_ACKNOWLEDGE_CODE': 'Invalid acknowledge code',
        'API.INVALID_ADDRESS': '無效地址',
        'API.INVALID_ADDRESS_VALUE': '無效地址值',
        'API.INVALID_ADVANCED_REPORT_ID': '無效的⾼級報表 ID',
        'API.INVALID_API_KEY_ID': 'Invalid api key id',
        'API.INVALID_API_KEY_NAME': 'Invalid api key name',
        'API.INVALID_AREA_VALUE': '無效⾯積值',
        'API.INVALID_BALANCING_PRICE_POINT_ID': 'Invalid balancing price point ID',
        'API.INVALID_BASE_PERIOD_END_DATETIME': '無效的基準期結束時間',
        'API.INVALID_BASE_PERIOD_START_DATETIME': '無效的基準期開始時間',
        'API.INVALID_BATTERY_STATE_POINT_ID': 'Invalid battery state point ID',
        'API.INVALID_BAUD_RATE': '無效波特率',
        'API.INVALID_BUILDINGS_VALUE': '無效的建築值',
        'API.INVALID_BUY_METER_ID': 'Invalid buy meter id',
        'API.INVALID_CAPACITY': 'Invalid capacity',
        'API.INVALID_CATEGORY': '無效類型',
        'API.INVALID_CHANNEL': '無效通道',
        'API.INVALID_CHARGE_METER_ID': 'Invalid charge meter id',
        'API.INVALID_COMBINED_EQUIPMENT_ID': '無效的組合設備 ID',
        'API.INVALID_COMBINED_EQUIPMENT_NAME': '無效的組合設備名稱',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_ID': '無效的組合設備相關參數 ID',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_NAME': '無效的組合設備相關參數名稱',
        'API.INVALID_COMBINED_EQUIPMENT_PARAMETER_TYPE': '無效的組合設備相關參數類型',
        'API.INVALID_COMBINED_EQUIPMENT_UUID': '無效的組合設備 UUIDs',
        'API.INVALID_COMMAND_ID': 'Invalid command id',
        'API.INVALID_COMMAND_NAME': 'Invalid command name',
        'API.INVALID_CONNECTION': '無效連接',
        'API.INVALID_CONSTANT_VALUE': '無效常量值',
        'API.INVALID_CONTACT_ID': '無效的聯絡⼈ ID',
        'API.INVALID_CONTACT_NAME': '無效的聯絡⼈姓名',
        'API.INVALID_COOLING_METER_ID': 'Invalid cooling meter id',
        'API.INVALID_COST_CENTER_ID': '無效的成本中⼼ ID',
        'API.INVALID_COST_FILE_ID': '無效的成本⽂件 ID',
        'API.INVALID_CREATED_DATETIME': 'Invalid created datetime',
        'API.INVALID_DATA_REPAIR_FILE_ID': 'Invalid data repair file id',
        'API.INVALID_DATA_SOURCE_ID': '無效的數據源 ID',
        'API.INVALID_DATA_SOURCE_NAME': '無效的數據源名稱',
        'API.INVALID_DATA_SOURCE_PROTOCOL': '無效的數據源協議',
        'API.INVALID_DATE_LOCAL': '無效的本地⽇期',
        'API.INVALID_DENOMINATOR_METER_UUID': '無效的標準計量表 UUID',
        'API.INVALID_DISCHARGE_METER_ID': 'Invalid discharge meter id',
        'API.INVALID_DISPLAY_NAME': '無效的顯⽰名稱',
        'API.INVALID_DISTRIBUTION_CIRCUIT_ID': '無效的配電回路 ID',
        'API.INVALID_DISTRIBUTION_CIRCUIT_NAME': '無效的配電回路名稱',
        'API.INVALID_DISTRIBUTION_ROOM': '無效的配電室',
        'API.INVALID_DISTRIBUTION_SYSTEM_ID': '無效的配電系統 ID',
        'API.INVALID_DISTRIBUTION_SYSTEM_NAME': '無效的配電系統名稱',
        'API.INVALID_ELECTRICITY_METER_ID': 'Invalid Electricity meter id',
        'API.INVALID_EMAIL': '無效的郵箱',
        'API.INVALID_EMAIL_MESSAGE_ID': '無效的電⼦郵件 ID',
        'API.INVALID_EMAIL_SERVER_HOST': '無效的電⼦郵箱服務器主機',
        'API.INVALID_EMAIL_SERVER_ID': '無效的電⼦郵箱服務器 ID',
        'API.INVALID_END_DATE_FORMAT': '無效的結束⽇期格式',
        'API.INVALID_END_DATETIME': '無效的結束⽇期',
        'API.INVALID_ENERGY_CATEGORY_ID': '無效的能源分類 ID',
        'API.INVALID_ENERGY_CATEGORY_NAME': '無效的能源分類名稱',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_ID': '無效的能流圖 ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_LINK_ID': '無效的能流圖鏈接 ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NAME': '無效的能流圖名稱',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_ID': '無效的能流圖節點 ID',
        'API.INVALID_ENERGY_FLOW_DIAGRAM_NODE_NAME': '無效的能流圖節點名稱',
        'API.INVALID_ENERGY_ITEM_ID': '無效的能源分項 ID',
        'API.INVALID_ENERGY_ITEM_NAME': '無效的能源分項名稱',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_ID': 'Invalid energy storage power station ID',
        'API.INVALID_ENERGY_STORAGE_POWER_STATION_NAME': 'Invalid energy storage power station name',
        'API.INVALID_EQUATION_IN_EXPRESSION': '表達式中無效的表達式',
        'API.INVALID_EQUIPMENT_ID': '無效的設備 ID',
        'API.INVALID_EQUIPMENT_NAME': '無效的設備名稱',
        'API.INVALID_EQUIPMENT_PARAMETER_ID': '無效的設備相關參數 ID',
        'API.INVALID_EQUIPMENT_PARAMETER_NAME': '無效的設備相關參數名稱',
        'API.INVALID_EQUIPMENT_PARAMETER_TYPE': '無效的設備相關參數類型',
        'API.INVALID_EQUIPMENT_UUID': '無效的設備 UUID',
        'API.INVALID_EXPIRES_DATETIME': 'Invalid expires datetime',
        'API.INVALID_EXPRESSION': '無效表達式',
        'API.INVALID_EXPRESSION_OBJECT': '無效的表達式對象',
        'API.INVALID_FDD_CODE': '無效的故障錯誤碼',
        'API.INVALID_FLOORS_VALUE': '無效的樓層值',
        'API.INVALID_FROM_ADDR': '無效地址',
        'API.INVALID_GATEWAY_ID': '無效的網關 ID',
        'API.INVALID_GATEWAY_NAME': '無效的網關名稱',
        'API.INVALID_HEAT_METER_ID': 'Invalid heat meter id',
        'API.INVALID_HIGH_LIMIT_VALUE': 'Invalid high limit value',
        'API.INVALID_HOURLY_HIGH_LIMIT_VALUE': '無效的⼩時上限值',
        'API.INVALID_HOURLY_LOW_LIMIT_VALUE': '無效的⼩時下限值',
        'API.INVALID_Id': 'Invalid id',
        'API.INVALID_IS_ADMIN_VALUE': '無效的管理值',
        'API.INVALID_IS_COST_DATA_DISPLAYED': '無效的是否顯⽰成本數據',
        'API.INVALID_IS_COUNTED_VALUE': '無效的計數值',
        'API.INVALID_IS_ENABLED': '無效的是否啟⽤',
        'API.INVALID_IS_HIDDEN': '無效的是否隱藏',
        'API.INVALID_IS_IN_LEASE_VALUE': '無效的是否在租值',
        'API.INVALID_IS_INPUT_COUNTED_VALUE': '無效的輸入是否匯總值',
        'API.INVALID_IS_KEY_TENANT_VALUE': '無效的是否主⼒租⼾值',
        'API.INVALID_IS_OUTPUT_COUNTED_VALUE': '無效的輸出是否匯總值',
        'API.INVALID_IS_OUTPUT_VALUE': '無效的輸出是否匯總值',
        'API.INVALID_IS_READ_ONLY_VALUE': 'Invalid is read only value',
        'API.INVALID_IS_TREND_VALUE': '無效的是否保存趨勢值',
        'API.INVALID_IS_VIRTUAL_VALUE': '無效的是否虛擬點值',
        'API.INVALID_KGCE': '無效的千克標準煤系數',
        'API.INVALID_KGCO2E': '無效的千克⼆氧化碳排放系數',
        'API.INVALID_KNOWLEDGE_FILE_ID': '無效的知識⽂件 ID',
        'API.INVALID_LATITUDE_VALUE': '無效的緯度值',
        'API.INVALID_LEASE_NUMBER_VALUE': '無效的租約編號',
        'API.INVALID_LONGITUDE_VALUE': '無效的經度值',
        'API.INVALID_LOW_LIMIT_VALUE': '無效的下限值',
        'API.INVALID_MASTER_METER_ID': '無效的總計量表 ID',
        'API.INVALID_MENU_ID': '無效的菜單 ID',
        'API.INVALID_MESSAGE_DATA': 'Invalid message data',
        'API.INVALID_MESSAGE_TEMPLATE': '無效的消息模板',
        'API.INVALID_MESSAGE_TEMPLATE_ID': 'Invalid message template id',
        'API.INVALID_MESSAGE_VALUE': 'Invalid message value',
        'API.INVALID_METER_ID': '無效的計量表 ID',
        'API.INVALID_METER_NAME': '無效的計量表名稱',
        'API.INVALID_METER_UUID': '無效的計量表 UUID',
        'API.INVALID_MICROGRID_BATTERY_ID': 'Invalid microgrid battery id',
        'API.INVALID_MICROGRID_BATTERY_NAME': 'Invalid microgrid battery name',
        'API.INVALID_MICROGRID_EVCHARGER_ID': 'Invalid microgrid evcharger id',
        'API.INVALID_MICROGRID_EVCHARGER_NAME': 'Invalid microgrid evcharger name',
        'API.INVALID_MICROGRID_GENERATOR_ID': 'Invalid microgrid generator id',
        'API.INVALID_MICROGRID_GENERATOR_NAME': 'Invalid microgrid generator name',
        'API.INVALID_MICROGRID_GRID_ID': 'Invalid microgrid grid id',
        'API.INVALID_MICROGRID_GRID_NAME': 'Invalid microgrid grid name',
        'API.INVALID_MICROGRID_HEATPUMP_ID': 'Invalid microgrid heatpump id',
        'API.INVALID_MICROGRID_HEATPUMP_NAME': 'Invalid microgrid heatpump name',
        'API.INVALID_MICROGRID_ID': 'Invalid microgrid id',
        'API.INVALID_MICROGRID_LOAD_ID': 'Invalid microgrid load id',
        'API.INVALID_MICROGRID_LOAD_NAME': 'Invalid microgrid load name',
        'API.INVALID_MICROGRID_NAME': 'Invalid microgrid name',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_ID': 'Invalid microgrid photovoltaic id',
        'API.INVALID_MICROGRID_PHOTOVOLTAIC_NAME': 'Invalid microgrid photovoltaic name',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_ID':
            'Invalid microgrid power conversion system ID',
        'API.INVALID_MICROGRID_POWER_CONVERSION_SYSTEM_NAME':
            'Invalid microgrid microgrid power conversion system name',
        'API.INVALID_MICROGRID_UUID': 'Invalid microgrid UUID',
        'API.INVALID_NAME_VALUE': '無效的名稱值',
        'API.INVALID_NEW_PASSWORD': '無效的新密碼',
        'API.INVALID_NON_WORKING_DAY_ID': '無效的非⼯作⽇ ID',
        'API.INVALID_NOTIFICATION_ID': '無效的通知 ID',
        'API.INVALID_NUMERATOR_METER_UUID': '無效的分⼦表 UUID',
        'API.INVALID_OBJECT_TYPE': '無效的對象類型',
        'API.INVALID_OFFLINE_METER_DATA': '無效離線表數據',
        'API.INVALID_OFFLINE_METER_FILE_ID': '無效的離線表⽂件 ID',
        'API.INVALID_OFFLINE_METER_ID': '無效的離線表 ID',
        'API.INVALID_OFFLINE_METER_NAME': '無效的離線表名稱',
        'API.INVALID_OFFLINE_METER_UUID': '無效的離線表 UUID',
        'API.INVALID_OFFSET_CONSTANT_VALUE': '無效的偏移常量',
        'API.INVALID_OLD_PASSWORD': '無效的舊密碼',
        'API.INVALID_OPENID': 'Invalid openid',
        'API.INVALID_PARENT_SPACE_ID': '無效的⽗空間 ID',
        'API.INVALID_PASSWORD': '無效的密碼',
        'API.INVALID_PAYLOAD': 'Invalid payload',
        'API.INVALID_PEAK_CURRENT': '無效峰值電流',
        'API.INVALID_PEAK_LOAD': '無效峰值負載',
        'API.INVALID_PERIOD_TYPE': '無效周期類型',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_ID': 'Invalid photovoltaic power station ID',
        'API.INVALID_PHOTOVOLTAIC_POWER_STATION_NAME': 'Invalid photovoltaic power station name',
        'API.INVALID_POINT_ID': '無效的數據點 ID',
        'API.INVALID_POINT_NAME': '無效的數據點名稱',
        'API.INVALID_PORT': '無效端⼝',
        'API.INVALID_POSTAL_CODE_VALUE': 'Invalid postal code value',
        'API.INVALID_POWER_POINT_ID': 'Invalid power point id',
        'API.INVALID_PRIORITY': '無效的優先級',
        'API.INVALID_PRIVILEGE': '無效的權限',
        'API.INVALID_PRIVILEGE_DATA': '無效的權限數據',
        'API.INVALID_PRIVILEGE_ID': '無效的權限 ID',
        'API.INVALID_PRIVILEGE_NAME': '無效的權限名稱',
        'API.INVALID_RATIO_VALUE': '無效的變比值',
        'API.INVALID_RECIPIENT_EMAIL': 'Invalid recipient email',
        'API.INVALID_RECIPIENT_MOBILE': 'Invalid recipient mobile',
        'API.INVALID_RECIPIENT_NAME': 'Invalid recipient name',
        'API.INVALID_RECIPIENT_OPENID': 'Invalid recipient openid',
        'API.INVALID_REPLY': '無效回覆',
        'API.INVALID_REPORTING_PERIOD_END_DATETIME': '無效的報告期結束⽇期時間',
        'API.INVALID_REPORTING_PERIOD_START_DATETIME': '無效的報告期開始⽇期時間',
        'API.INVALID_REQUIRES_AUTHENTICATION': '無效的需要⾝份驗證',
        'API.INVALID_ROOMS_VALUE': '無效的房間值',
        'API.INVALID_RULE_ID': '無效的規則 ID',
        'API.INVALID_RULE_NAME': '無效的規則名稱',
        'API.INVALID_RUN_STATE_POINT_ID': 'Invalid run state point ID',
        'API.INVALID_SCHEDULED_DATETIME': 'Invalid scheduled datetime',
        'API.INVALID_SELL_METER_ID': 'Invalid sell meter id',
        'API.INVALID_SENSOR_ID': '無效的傳感器 ID',
        'API.INVALID_SENSOR_NAME': '無效的傳感器名稱',
        'API.INVALID_SENSOR_UUID': 'Invalid sensor uuid',
        'API.INVALID_SERIAL_NUMBER': 'Invalid serial number',
        'API.INVALID_SERIAL_PORT': '無效的串⼝號',
        'API.INVALID_SESSION_PLEASE_RE_LOGIN': '會話無效，請重新登陸',
        'API.INVALID_SET_VALUE': 'Invalid set value',
        'API.INVALID_SHOPFLOOR_ID': '無效的⾞間 ID',
        'API.INVALID_SHOPFLOOR_NAME': '無效的⾞間名稱',
        'API.INVALID_SHOPFLOOR_UUID': '無效的⾞間 UUID',
        'API.INVALID_SOURCE_NODE_ID': '無效的源節點 ID',
        'API.INVALID_SPACE_ID': '無效的空間 ID',
        'API.INVALID_SPACE_NAME': '無效的空間名稱',
        'API.INVALID_SPACE_UUID': '無效的空間 UUID',
        'API.INVALID_START_DATE_FORMAT': '無效的開始時間格式',
        'API.INVALID_START_DATETIME': '無效的開始時間',
        'API.INVALID_STATUS': '無效狀態',
        'API.INVALID_STORE_ID': '無效⾨店 ID',
        'API.INVALID_STORE_NAME': '無效⾨店名稱',
        'API.INVALID_STORE_TYPE_DESCRIPTION': '無效的⾨店類型描述',
        'API.INVALID_STORE_TYPE_ID': '無效的⾨店類型 ID',
        'API.INVALID_STORE_TYPE_NAME': '無效的⾨店類型名稱',
        'API.INVALID_STORE_TYPE_SIMPLIFIED_CODE': '無效的⾨店類型簡化代碼',
        'API.INVALID_STORE_UUID': '無效⾨店 UUID',
        'API.INVALID_SUBJECT_VALUE': 'Invalid subject value',
        'API.INVALID_SVG': '無效 SVG',
        'API.INVALID_SWITCHGEAR': '無效的開關設備',
        'API.INVALID_TARGET_NODE_ID': '無效的⽬標節點 ID',
        'API.INVALID_TARIFF_BLOCK_PRICING': '無效的階梯費率定價',
        'API.INVALID_TARIFF_ID': '無效的費率 ID',
        'API.INVALID_TARIFF_TIME_OF_USE_PRICING': '無效的分時費率定價',
        'API.INVALID_TARIFF_TYPE': '無效的費率類型',
        'API.INVALID_TENANT_ID': '無效的租⼾ ID',
        'API.INVALID_TENANT_NAME': '無效的租⼾名稱',
        'API.INVALID_TENANT_TYPE_DESCRIPTION': '無效的租⼾類型描述',
        'API.INVALID_TENANT_TYPE_ID': '無效的租⼾類型 ID',
        'API.INVALID_TENANT_TYPE_NAME': '無效的租⼾類型名稱',
        'API.INVALID_TENANT_TYPE_SIMPLIFIED_CODE': '無效的租⼾類型簡化代碼',
        'API.INVALID_TENANT_UUID': '無效的租⼾ UUID',
        'API.INVALID_TEXT_MESSAGE_ID': '無效的短信 ID',
        'API.INVALID_TIMEZONE_ID': '無效的時區 ID',
        'API.INVALID_TOKEN': '無效令牌',
        'API.INVALID_TOPIC': 'Invalid topic',
        'API.INVALID_UNIT_OF_MEASURE': '無效的計量單位',
        'API.INVALID_UNIT_OF_PRICE': '無效的價格單位',
        'API.INVALID_UNITS': '無效單位',
        'API.INVALID_USER_ID': '無效的⽤⼾ ID',
        'API.INVALID_USER_NAME': '無效的⽤⼾名稱',
        'API.INVALID_USER_NAME_OR_EMAIL': '無效的⽤⼾名稱或郵箱',
        'API.INVALID_USER_PHONE': '無效的⽤⼾⼿機號',
        'API.INVALID_USER_PLEASE_RE_LOGIN': '無效的⽤⼾請重新登錄',
        'API.INVALID_USER_UUID': '無效的⽤⼾ UUID',
        'API.INVALID_USERNAME': 'Invalid userName',
        'API.INVALID_VARIABLE_METER_ID': '無效的變量計量表 ID',
        'API.INVALID_VARIABLE_METER_TYPE': '無效的變量計量表類型',
        'API.INVALID_VARIABLE_NAME': '無效的變量名稱',
        'API.INVALID_VERIFICATION_CODE': '無效的驗證碼',
        'API.INVALID_VIRTUAL_METER_ID': '無效的虛擬表 ID',
        'API.INVALID_VIRTUAL_METER_NAME': '無效的虛擬表名稱',
        'API.INVALID_VIRTUAL_METER_UUID': '無效的虛擬表 UUID',
        'API.INVALID_WEB_MESSAGE_ID': '無效的 web 消息 ID',
        'API.INVALID_WECHAT_MESSAGE_ID': '無效的微信消息 ID',
        'API.INVALID_WIND_FARM_ID': 'Invalid wind farm ID',
        'API.INVALID_WIND_FARM_NAME': 'Invalid wind farm name',
        'API.INVALID_WORKING_CALENDAR_ID': '無效的⼯作⽇歷 ID',
        'API.INVALID_WORKING_CALENDAR_NAME': '無效的⼯作⽇歷名稱',
        'API.KNOWLEDGE_FILE_CANNOT_BE_REMOVED_FROM_DISK': '無法從磁盤中刪除知識⽂件',
        'API.KNOWLEDGE_FILE_NOT_FOUND': '知識庫⽂件不存在',
        'API.MASTER_METER_DOES_NOT_BELONG_TO_SAME_ENERGY_CATEGORY': '總表不屬於同⼀能源分類',
        'API.MASTER_METER_NOT_FOUND': '總表不存在',
        'API.MENU_NOT_FOUND': '菜單不存在',
        'API.METER_CANNOT_HAVE_MORE_THAN_ONE_ENERGY_VALUE_POINTS': 'Meter cannot have more than one energy value points',
        'API.METER_COMMAND_RELATION_EXISTS': 'Meter command relation exists',
        'API.METER_COMMAND_RELATION_NOT_FOUND': 'Meter command relation not found',
        'API.METER_NAME_IS_ALREADY_IN_USE': '計量表名稱已使⽤',
        'API.METER_NOT_FOUND': '計量表不存在',
        'API.METER_OF_VARIABLE_NOT_FOUND': '計量表變量不存在',
        'API.METER_POINT_RELATION_EXISTS': '計量表與數據點關系已存在',
        'API.METER_POINT_RELATION_NOT_FOUND': '計量表與數據點關系不存在',
        'API.MICROGRID_BATTERY_NAME_IS_ALREADY_IN_USE': 'Microgrid battery name is already in use',
        'API.MICROGRID_BATTERY_NOT_FOUND': 'Microgrid battery not found',
        'API.MICROGRID_EVCHARGER_NAME_IS_ALREADY_IN_USE':
            'Microgrid evcharger name is already in use',
        'API.MICROGRID_EVCHARGER_NOT_FOUND': 'Microgrid evcharger not fund',
        'API.MICROGRID_GENERATOR_NAME_IS_ALREADY_IN_USE':
            'Microgrid generator name is already in use',
        'API.MICROGRID_GENERATOR_NOT_FOUND': 'Microgrid generator not found',
        'API.MICROGRID_GRID_NAME_IS_ALREADY_IN_USE': 'Microgrid grid name is already in use',
        'API.MICROGRID_GRID_NOT_FOUND': 'Microgrid grid not found',
        'API.MICROGRID_HEATPUMP_NAME_IS_ALREADY_IN_USE': 'Microgrid heatpump name is already in use',
        'API.MICROGRID_HEATPUMP_NOT_FOUND': 'Microgrid heatpump not found',
        'API.MICROGRID_LOAD_NAME_IS_ALREADY_IN_USE': 'Microgrid load name is already',
        'API.MICROGRID_LOAD_NOT_FOUND': 'Microgrid load not found',
        'API.MICROGRID_NAME_IS_ALREADY_IN_USE': 'Microgrid name is already in use',
        'API.MICROGRID_NOT_FOUND': 'Microgrid not found',
        'API.MICROGRID_PHOTOVOLTAIC_NAME_IS_ALREADY_IN_USE':
            'Microgrid photovoltaic name is already in use',
        'API.MICROGRID_PHOTOVOLTAIC_NOT_FOUND': 'Microgrid photovoltaic not found',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NAME_IS_ALREADY_IN_USE':
            'Microgrid power conversion system name is already in use',
        'API.MICROGRID_POWER_CONVERSION_SYSTEM_NOT_FOUND':
            'Microgrid power conversion system not found',
        'API.MICROGRID_SENSOR_RELATION_EXISTS': 'Microgrid sensor relation exists',
        'API.MICROGRID_SENSOR_RELATION_NOT_FOUND': 'Microgrid sensor not found',
        'API.MQTT_CONNECTION_ERROR': 'Mqtt connection error',
        'API.MQTT_PUBLISH_ERROR': 'Mqtt publish error',
        'API.NEW_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            '新密碼長度不能超過 100 個字符',
        'API.NEW_USER_SESSION_NOT_FOUND': 'New user session not found',
        'API.NEW_USER_SESSION_TIMEOUT': 'New user session timeout',
        'API.NON_WORKING_DAY_NOT_FOUND': '非⼯作⽇不存在',
        'API.NOT_FOUND': '不存在',
        'API.NOTIFICATION_NOT_FOUND': '通知不存在',
        'API.OFFLINE_METER_FILE_NOT_FOUND': '離線表⽂件不存在',
        'API.OFFLINE_METER_NAME_IS_ALREADY_IN_USE': '離線表名稱已使⽤',
        'API.OFFLINE_METER_NOT_FOUND': '離線表不存在',
        'API.INVALID_OFFLINE_METER_VALUE': '無效的離線數據',
        'API.OFFLINE_METER_OF_VARIABLE_NOT_FOUND': '離線表變量不存在',
        'API.OLD_PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS':
            '舊密碼長度不能超過 100 個字符',
        'API.PARENT_SPACE_NOT_FOUND': '⽗空間不存在',
        'API.PASSWORD_LENGTH_CANNOT_EXCEED_100_CHARACTERS': '密碼長度不能超過 100 個字符',
        'API.PASSWORDS_MATCH': '新密碼與舊密碼⼀致',
        'API.PHOTOVOLTAIC_POWER_STATION_NAME_IS_ALREADY_IN_USE':
            'Photovoltaic power station name is already in use',
        'API.PHOTOVOLTAIC_POWER_STATION_NOT_FOUND': 'Photovoltaic power station not found',
        'API.POINT_NAME_IS_ALREADY_IN_USE': '數據點名稱已使⽤',
        'API.POINT_NOT_FOUND': '數據點不存在',
        'API.POWER_POINT_NOT_FOUND': 'Power point not found',
        'API.PRIVILEGE_NAME_IS_ALREADY_IN_USE': '權限名稱已使⽤',
        'API.PRIVILEGE_NOT_FOUND': '權限不存在',
        'API.RULE_NAME_IS_ALREADY_IN_USE': '規則名稱已使⽤',
        'API.RULE_NOT_FOUND': '規則不存在',
        'API.SELL_METER_NOT_FOUND': 'Sell meter not found',
        'API.SENSOR_NAME_IS_ALREADY_IN_USE': '傳感器名稱已使⽤',
        'API.SENSOR_NOT_FOUND': '傳感器不存在',
        'API.SENSOR_POINT_RELATION_EXISTS': '傳感器與數據點關系已存在',
        'API.SENSOR_POINT_RELATION_NOT_FOUND': '傳感器與數據點關系不存在',
        'API.SHOPFLOOR_COMMAND_RELATION_EXISTS': 'Shopfloor command relation exists',
        'API.SHOPFLOOR_COMMAND_RELATION_NOT_FOUND': 'Shopfloor command relation not found',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_EXISTS': '⾞間與設備關系已存在',
        'API.SHOPFLOOR_EQUIPMENT_RELATION_NOT_FOUND': '⾞間與設備關系不存在',
        'API.SHOPFLOOR_METER_RELATION_EXISTS': '⾞間與計量表關系已存在',
        'API.SHOPFLOOR_METER_RELATION_NOT_FOUND': '⾞間與計量表關系不存在',
        'API.SHOPFLOOR_NAME_IS_ALREADY_IN_USE': '⾞間名稱已使⽤',
        'API.SHOPFLOOR_NOT_FOUND': '⾞間不存在',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_EXISTS': '⾞間與離線表關系已存在',
        'API.SHOPFLOOR_OFFLINE_METER_RELATION_NOT_FOUND': '⾞間與離線表關系不存在',
        'API.SHOPFLOOR_POINT_RELATION_EXISTS': '⾞間與數據點關系已存在',
        'API.SHOPFLOOR_POINT_RELATION_NOT_FOUND': '⾞間與數據點關系不存在',
        'API.SHOPFLOOR_SENSOR_RELATION_EXISTS': '⾞間與傳感器關系已存在',
        'API.SHOPFLOOR_SENSOR_RELATION_NOT_FOUND': '⾞間與傳感器關系不存在',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_EXISTS': '⾞間與虛擬表關系已存在',
        'API.SHOPFLOOR_VIRTUAL_METER_RELATION_NOT_FOUND': '⾞間與虛擬表關系不存在',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_EXISTS': '⾞間⼯作⽇歷關系已存在',
        'API.SHOPFLOOR_WORKING_CALENDAR_RELATION_NOT_FOUND':
            '⾞間與⼯作⽇歷關系不存在',
        'API.SOC_POINT_NOT_FOUND': 'SOC point not found',
        'API.SOURCE_NODE_NOT_FOUND': '源節點不存在',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_EXISTS': '空間與組合設備關系已存在',
        'API.SPACE_COMBINED_EQUIPMENT_RELATION_NOT_FOUND': '空間與組合設備關系不存在',
        'API.SPACE_COMMAND_RELATION_EXISTS': 'Space command relation exists',
        'API.SPACE_COMMAND_RELATION_NOT_FOUND': 'Space command relation not found',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_EXISTS':
            'Space Energy Storage Power Station Relation Exists',
        'API.SPACE_ENERGY_STORAGE_POWER_STATION_RELATION_NOT_FOUND': 'Space Energy Storage Power Station Relation Not Found',
        'API.SPACE_EQUIPMENT_RELATION_EXISTS': '空間與設備關系已存在',
        'API.SPACE_EQUIPMENT_RELATION_NOT_FOUND': '空間與設備關系不存在',
        'API.SPACE_METER_RELATION_EXISTS': '空間與計量表關系已存在',
        'API.SPACE_METER_RELATION_NOT_FOUND': '空間與計量表關系不存在',
        'API.SPACE_NAME_IS_ALREADY_IN_USE': '空間名稱已使⽤',
        'API.SPACE_NOT_FOUND': '空間不存在',
        'API.SPACE_NOT_FOUND_IN_PRIVILEGE': '空間在權限中不存在',
        'API.SPACE_OFFLINE_METER_RELATION_EXISTS': '空間與離線表關系已存在',
        'API.SPACE_OFFLINE_METER_RELATION_NOT_FOUND': '空間與離線表關系不存在',
        'API.SPACE_POINT_RELATION_EXISTS': '空間與數據點關系已存在',
        'API.SPACE_POINT_RELATION_NOT_FOUND': '空間與數據點關系不存在',
        'API.SPACE_SENSOR_RELATION_EXISTS': '空間與傳感器關系已存在',
        'API.SPACE_SENSOR_RELATION_NOT_FOUND': '空間與傳感器關系不存在',
        'API.SPACE_SHOPFLOOR_RELATION_EXISTS': '空間與⾞間關系已存在',
        'API.SPACE_SHOPFLOOR_RELATION_NOT_FOUND': '空間與⾞間關系不存在',
        'API.SPACE_STORE_RELATION_EXISTS': '空間與⾨店關系已存在',
        'API.SPACE_STORE_RELATION_NOT_FOUND': '空間與⾨店關系不存在',
        'API.SPACE_TENANT_RELATION_EXISTS': '空間與租⼾關系已存在',
        'API.SPACE_TENANT_RELATION_NOT_FOUND': '空間與租⼾關系不存在',
        'API.SPACE_VIRTUAL_METER_RELATION_EXISTS': '空間與虛擬表關系已存在',
        'API.SPACE_VIRTUAL_METER_RELATION_NOT_FOUND': '空間與虛擬表關系不存在',
        'API.SPACE_WORKING_CALENDAR_RELATION_EXISTS': '空間與⼯作⽇歷關系已存在',
        'API.SPACE_WORKING_CALENDAR_RELATION_NOT_FOUND': '空間與⼯作⽇歷關系不存在',
        'API.START_DATETIME_MUST_BE_EARLIER_THAN_END_DATETIME':
            '開始⽇期時間必須早於結束⽇期時間',
        'API.STORE_COMMAND_RELATION_EXISTS': 'Store command relation exists',
        'API.STORE_COMMAND_RELATION_NOT_FOUND': 'Store command relation not found',
        'API.STORE_METER_RELATION_EXISTS': '⾨店與計量表關系已存在',
        'API.STORE_METER_RELATION_NOT_FOUND': '⾨店與計量表關系不存在',
        'API.STORE_NAME_IS_ALREADY_IN_USE': '⾨店名稱已使⽤',
        'API.STORE_NOT_FOUND': '⾨店不存在',
        'API.STORE_OFFLINE_METER_RELATION_EXISTS': '⾨店與離線表關系已存在',
        'API.STORE_OFFLINE_METER_RELATION_NOT_FOUND': '⾨店與離線表關系不存在',
        'API.STORE_POINT_RELATION_EXISTS': '⾨店與數據點關系已存在',
        'API.STORE_POINT_RELATION_NOT_FOUND': '⾨店與數據點關系不存在',
        'API.STORE_SENSOR_RELATION_EXISTS': '⾨店與傳感器關系已存在',
        'API.STORE_SENSOR_RELATION_NOT_FOUND': '⾨店傳感器關系不存在',
        'API.STORE_TYPE_NAME_IS_ALREADY_IN_USE': '⾨店類型名稱已使⽤',
        'API.STORE_TYPE_NOT_FOUND': '⾨店類型不存在',
        'API.STORE_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '⾨店類型簡化代碼已使⽤',
        'API.STORE_TYPE_USED_IN_STORE': '⾨店類型在⾨店中已使⽤',
        'API.STORE_VIRTUAL_METER_RELATION_EXISTS': '⾨店與虛擬表關系已存在',
        'API.STORE_VIRTUAL_METER_RELATION_NOT_FOUND': '⾨店與虛擬表關系不存在',
        'API.STORE_WORKING_CALENDAR_RELATION_EXISTS': '⾨店與⼯作⽇歷關系已存在',
        'API.STORE_WORKING_CALENDAR_RELATION_NOT_FOUND': '⾨店與⼯作⽇歷關系不存在',
        'API.TARGET_NODE_NOT_FOUND': '⽬標節點不存在',
        'API.TARIFF_IN_USE': '費率正在使⽤',
        'API.TARIFF_IS_ALREADY_ASSOCIATED_WITH_COST_CENTER': '費率和成本中⼼已關聯',
        'API.TARIFF_IS_NOT_ASSOCIATED_WITH_COST_CENTER': '費率和成本中⼼未關聯',
        'API.TARIFF_NAME_IS_ALREADY_IN_USE': '費率名稱已使⽤',
        'API.TARIFF_NOT_FOUND': '費率不存在',
        'API.TENANT_COMMAND_RELATION_EXISTS': 'Tenant command relation exists',
        'API.TENANT_COMMAND_RELATION_NOT_FOUND': 'Tenant command relation not found',
        'API.TENANT_METER_RELATION_EXISTS': '租⼾與計量表關系已存在',
        'API.TENANT_METER_RELATION_NOT_FOUND': '租⼾與計量表關系不存在',
        'API.TENANT_NAME_IS_ALREADY_IN_USE': '租⼾名稱已使⽤',
        'API.TENANT_NOT_FOUND': '租⼾不存在',
        'API.TENANT_OFFLINE_METER_RELATION_EXISTS': '租⼾與離線表關系已存在',
        'API.TENANT_OFFLINE_METER_RELATION_NOT_FOUND': '租⼾與離線表關系不存在',
        'API.TENANT_POINT_RELATION_EXISTS': '租⼾與數據點關系已存在',
        'API.TENANT_POINT_RELATION_NOT_FOUND': '租⼾與數據點關系不存在',
        'API.TENANT_SENSOR_RELATION_EXISTS': '租⼾與傳感器關系已存在',
        'API.TENANT_SENSOR_RELATION_NOT_FOUND': '租⼾與傳感器關系不存在',
        'API.TENANT_TYPE_NAME_IS_ALREADY_IN_USE': '租⼾與類型名稱已使⽤',
        'API.TENANT_TYPE_NOT_FOUND': '租⼾類型不存在',
        'API.TENANT_TYPE_SIMPLIFIED_CODE_IS_ALREADY_IN_USE': '租⼾類型簡化代碼已使⽤',
        'API.TENANT_TYPE_USED_IN_TENANT': '租⼾類型在租⼾中已使⽤',
        'API.TENANT_VIRTUAL_METER_RELATION_EXISTS': '租⼾與虛擬表關系已存在',
        'API.TENANT_VIRTUAL_METER_RELATION_NOT_FOUND': '租⼾與虛擬表關系不存在',
        'API.TENANT_WORKING_CALENDAR_RELATION_EXISTS': '租⼾與⼯作⽇歷關系已存在',
        'API.TENANT_WORKING_CALENDAR_RELATION_NOT_FOUND': '租⼾與⼯作⽇歷關系不存在',
        'API.TEXT_MESSAGE_NOT_FOUND': '未找到短信',
        'API.THE_REPORTING_PERIOD_MUST_BE_LONGER_THAN_15_MINUTES':
            '報告期必須⼤於 15 分鐘',
        'API.THERE_IS_RELATION_WITH_CHILD_METERS': '與⼦表有關系',
        'API.THERE_IS_RELATION_WITH_CHILDREN_SPACES': '與⼦空間有關系',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENT_PARAMETERS': '與組合設備相關參數有關系',
        'API.THERE_IS_RELATION_WITH_COMBINED_EQUIPMENTS': '與組合設備有關系',
        'API.THERE_IS_RELATION_WITH_DATA_SOURCES': '與數據源有關系',
        'API.THERE_IS_RELATION_WITH_ENERGY_FLOW_DIAGRAM_LINKS':
            '與能流圖有關系',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_BATTERIES': '與儲能集裝箱電池有關係',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_GRIDS': '與儲能集裝箱電網有關係',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_LOADS': '與儲能集裝箱負載有關係',
        'API.THERE_IS_RELATION_WITH_ENERGY_STORAGE_CONTAINERS_POWER_CONVERSION_SYSTEMS': '與儲能集裝箱功率轉換系統(PCS)有關係',
        'API.THERE_IS_RELATION_WITH_EQUIPMENT_PARAMETERS': '與設備相關參數有關系',
        'API.THERE_IS_RELATION_WITH_EQUIPMENTS': '與設備有關系',
        'API.THERE_IS_RELATION_WITH_METER': '與計量表有關系',
        'API.THERE_IS_RELATION_WITH_METERS': '與多個記量表有關系',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METER': '與離線表有關系',
        'API.THERE_IS_RELATION_WITH_OFFLINE_METERS': '與多個離線表有關系',
        'API.THERE_IS_RELATION_WITH_OTHER_VIRTUAL_METERS': '與虛擬表有關系',
        'API.THERE_IS_RELATION_WITH_SENSORS': '與傳感器有關系',
        'API.THERE_IS_RELATION_WITH_SHOPFLOORS': '與⾞間有關系',
        'API.THERE_IS_RELATION_WITH_SPACES': '與空間有關系',
        'API.THERE_IS_RELATION_WITH_STORES': '與⾨店有關系',
        'API.THERE_IS_RELATION_WITH_TENANTS': '與租⼾有關系',
        'API.THERE_IS_RELATION_WITH_USERS': '與⽤⼾有關系',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_METER': '與虛擬表有關系',
        'API.THERE_IS_RELATION_WITH_VIRTUAL_POWER_PLANTS': '與虛擬電廠有關系',
        'API.THIS_DATA_SOURCE_IS_BEING_USED_BY_A_METER': '這個數據源正在被⼀個計量表使⽤',
        'API.THIS_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '這個計量表正在被⼀個虛擬表使⽤',
        'API.THIS_OFFLINE_METER_IS_BEING_USED_BY_A_VIRTUAL_METER': '這個離線表正在被⼀個虛擬表使⽤',
        'API.THIS_SPACE_CANNOT_BE_CLONED': '空間不能被克隆',
        'API.THIS_SPACE_CANNOT_BE_DELETED': '空間不能被刪除',
        'API.TIMEZONE_NOT_FOUND': '時區不存在',
        'API.TOKEN_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '未找到令牌，請登錄',
        'API.USER_ACCOUNT_HAS_BEEN_LOCKED': '⽤⼾帳號已鎖定',
        'API.USER_ACCOUNT_HAS_EXPIRED': '⽤⼾帳號已過期',
        'API.USER_ACCOUNT_IS_NOT_LOCKED': 'User account is not locked',
        'API.USER_NAME_IS_ALREADY_IN_USE': '⽤⼾名已使⽤',
        'API.USER_NOT_FOUND': '⽤⼾不存在',
        'API.USER_PASSWORD_HAS_EXPIRED': '⽤⼾密碼已過期',
        'API.USER_PRIVILEGE_NOT_FOUND': '未發現⽤⼾權限',
        'API.USER_SESSION_NOT_FOUND': '未發現⽤⼾會話',
        'API.USER_SESSION_TIMEOUT': '⽤⼾會話已過期',
        'API.USER_UUID_NOT_FOUND_IN_HEADERS_PLEASE_LOGIN': '⽤⼾ UUID 不存在，請登錄',
        'API.VIRTUAL_METER_NAME_IS_ALREADY_IN_USE': '虛擬表名稱已使⽤',
        'API.VIRTUAL_METER_NOT_FOUND': '虛擬表不存在',
        'API.VIRTUAL_METER_OF_VARIABLE_NOT_FOUND': '變量的虛擬表不存在',
        'API.VIRTUAL_POINT_SHOULD_BE_ANALOG_VALUE': '虛擬數據點應該是模擬量',
        'API.WEB_MESSAGE_NOT_FOUND': 'web 信息不存在',
        'API.WECHAT_MESSAGE_NOT_FOUND': '微信信息不存在',
        'API.WIND_FARM_NAME_IS_ALREADY_IN_USE': 'Wind farm name is already in use',
        'API.WIND_FARM_NOT_FOUND': 'Wind farm not found',
        'API.WORKING_CALENDAR_NAME_IS_ALREADY_IN_USE': '⼯作⽇歷名稱已使⽤',
        'API.WORKING_CALENDAR_NOT_FOUND': '⼯作⽇歷不存在',

        MasterMeter: '總表',
        SubMeter: '分錶',
        'Power Quality': '電能品質',
        'About Power Quality': '關於電能品質',
        Category: '類別',
        Type: '類型',
        Limit: '限值',
        'Normal Limit': '正常限值',
        'Severe Limit': '嚴重限值',
        Compliance: '合規率',
        'Worst Deviation': '最差偏差',
        'Worst Time': '最差發生時間',
        'Severe Exceed Count': '嚴重越限次數',
        'Worst Unbalance': '最大不平衡率',
        Hz: '赫茲',
        voltage: '電壓',
        current: '電流',
        frequency: '頻率',
        voltage_deviation: '電壓偏差',
        current_unbalance: '電流不平衡',
        voltage_unbalance: '電壓不平衡',
        mean_deviation_pct: '平均偏差(%)',
        p95_abs_deviation_pct: 'P95絕對偏差(%)',
        mean_abs_deviation_hz: '平均絕對偏差(Hz)',
        frequency_deviation: '頻率偏差',
        p95_abs_deviation_hz: 'P95絕對偏差(Hz)',
        mean_unbalance_pct: '平均不平衡率(%)',
        p95_unbalance_pct: 'P95不平衡率(%)',
        count: '計數',
        min: '最小值',
        max: '最大值',
        mean: '平均值',
        std: '標準差',
        p5: 'P5',
        p95: 'P95'
    }
};
